
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IconName, iconNames } from "@/lib/icons/icons";
@Component({})
export default class ElementStudioIconsAutocomplete extends Vue {
  @Prop()
  value!: IconName | string;

  get iconNames() {
    return iconNames;
  }
}
